module.exports = __webpack_public_path__ + "img/accra-polo.ac8160ff.png";